<sdps-modal-beta sdps-title="Override overdraft rules violation" id="overdraft-override-confirmation-modal">
    <div slot="modal-body">
        <div class="sdps-text-body"><span>{{title}}</span></div><br>
    </div>
    <div slot="modal-footer">
        <button (click)="onCancelClick()" type="button"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
        <button (click)="onConfirmClick()" type="button"
            class="sdps-button sdps-button--primary sdps-button--small">Confirm</button>
    </div>
</sdps-modal-beta>